import { InjectionToken } from '@angular/core';

export const SITEMAP_DICTIONARY = new InjectionToken('SITEMAP_DICTIONARY');

export const ADDITIONAL_SITEMAP_ROUTES = new InjectionToken<
  Record<string, string>
>('ADDITIONAL_SITEMAP_ROUTES');
